import { Grid, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import AppSkeleton from "../AppSkeleton";
import { useCurrentUserData } from "../CurrentUserProvider";
import isMobileDevice from "../lib/isMobileDevice";
import Link from "../lib/Link";
import AmeelioConnect from "./AmeelioConnect.svg";
import BackToBack from "./BackToBack.svg";

export default function HomeScreen() {
  const { t } = useTranslation();

  const data = useCurrentUserData();
  // ameelio staff
  if (
    data?.me?.__typename === "Staff" ||
    data?.me?.__typename === "AmeelioStaff"
  )
    return <Navigate to="/toolbox" />;
  // family, friends, and service providers
  if (data?.me?.__typename === "Visitor") return <Navigate to="/home" />;
  if (data.loading) return <AppSkeleton />;

  return (
    <Grid container sx={{ height: 1 }}>
      <Stack
        sx={{
          m: "auto",
          width: 300,
          gap: 8,
        }}
      >
        <Stack
          sx={{
            gap: 2,
          }}
        >
          <img src={AmeelioConnect} alt="Ameelio Connect" />
          <img
            src={BackToBack}
            alt="Two people using a phone and tablet to talk"
          />
        </Stack>

        <Stack
          component="nav"
          sx={{
            gap: 2,
          }}
        >
          <Link button variant="contained" to="/login">
            {t("Sign in")}
          </Link>
          <Link button variant="outlined" to="/signup">
            {t("Create account")}
          </Link>
          {isMobileDevice() && (
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                mx: "-10px",
              }}
            >
              <a href="https://play.google.com/store/apps/details?id=com.connectmobile">
                <img
                  alt={t("Get it on Google Play")}
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  height="60"
                />
              </a>
              <a href="https://apps.apple.com/us/app/ameelio-connect/id1552990942">
                <img
                  alt={t("Download on the App Store")}
                  src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg"
                  height="60"
                  style={{ padding: "10px" }}
                />
              </a>
            </Stack>
          )}
        </Stack>
      </Stack>
    </Grid>
  );
}
